import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";

import { PLACEMENT_PATHS } from "../../Placements/paths";

export function BrowseJobsCta() {
  return (
    <SelectableBox withCallToActionIcon href={PLACEMENT_PATHS.ROOT} startIconType="briefcase">
      Browse Jobs
    </SelectableBox>
  );
}
